<script>
import {
  isDotNetDate,
  convertDotNetDateToJSDate,
} from '../../../static/js/dateHelpers';
export default {
  props: [
    'searchResults',
    'searchHitShowText',
    'searchHitsText',
    'applicationOpenText',
    'applicationClosedText',
    'applicationLateText',
    'applicationCanceledText',
    'hitCourseText',
    'hitProgramText',
    'educationOccasionText',
    'educationOccasionsText',
  ],
  data() {
    return {
      currentDate: undefined,
      items: undefined,
      searchHitsCount: this.searchResults && this.searchResults.NumberOfHits,
      searchHitShow: this.searchHitShowText,
      searchHits: this.searchHitsText,
      applicationOpen: this.applicationOpenText,
      applicationClosed: this.applicationClosedText,
      applicationLate: this.applicationLateText,
      applicationCanceled: this.applicationCanceledText,
      hitCourse: this.hitCourseText,
      hitProgram: this.hitProgramText,
      educationOccasion: this.educationOccasionText,
      educationOccasions: this.educationOccasionsText,
    };
  },
  methods: {
    convertApplicationDeadLineDates(items) {
      items.forEach((element) => {
        if (element.EducationOccasions.length > 0) {
          element.EducationOccasions.map((occasion) => {
            if (typeof occasion.ApplicationDeadLine === 'string') {
              let rawClosedDate = occasion.ApplicationClosed;
              let rawDeadlineDate = occasion.ApplicationDeadLine;

              if (isDotNetDate(rawClosedDate)) {
                rawClosedDate = convertDotNetDateToJSDate(rawClosedDate);
              }
              if (isDotNetDate(rawDeadlineDate)) {
                rawDeadlineDate = convertDotNetDateToJSDate(rawDeadlineDate);
              }

              const closedDate = new Date(rawClosedDate);
              const deadLineDate = new Date(rawDeadlineDate);

              occasion.ApplicationClosed = closedDate;
              occasion.ApplicationDeadLine = deadLineDate;
            }
          });
        }
      });
    },
    /**
     * Decides if specified 'Dot' should be shown in a educationOccasion
     *
     * @param {*} key should be 'open', 'late', 'closed' or 'canceled'
     * @param {*} occasion
     * @returns
     */
    showDot(key, occasion) {
      const { Canceled } = occasion;
      const { currentDate } = this;
      const ApplicationDeadLine = new Date(occasion.ApplicationDeadLine);
      const ApplicationClosed = new Date(occasion.ApplicationClosed);
      switch (key) {
        case 'open':
          return (
            currentDate < ApplicationDeadLine &&
            currentDate < ApplicationClosed &&
            !Canceled
          );
        case 'late':
          return (
            currentDate > ApplicationDeadLine &&
            currentDate < ApplicationClosed &&
            !Canceled
          );
        case 'closed':
          return currentDate > ApplicationClosed && !Canceled;
        case 'canceled':
          return Canceled;
      }
    },
  },
  mounted() {
    this.currentDate = new Date();
    this.items = this.searchResults?.Hits || [];
    if (!this.showPrograms && !this.showCourses) {
      this.convertApplicationDeadLineDates(this.items);
    }
  },
  watch: {
    searchResults: function () {
      this.items = this.searchResults.Hits;
      this.searchHitsCount = this.searchResults.NumberOfHits;
    },
  },
};
</script>

<template>
  <div class="hitsarea">
    <div
      v-if="searchHitsCount && items"
      class="hits--count d-flex flex-row flex-wrap align-items-center">
      <p>
        {{ searchHitShowText }}
        <strong>{{ searchHitsCount }}</strong> {{ searchHitsText }}
      </p>
    </div>
    <template v-if="items">
      <ul class="list-unstyled mb-0" v-for="(item, index) in items">
        <template
          v-if="item.Type.includes('Program')"
          class="hits--inner"
          :icon="'custom'">
          <li :key="item.Code">
            <div class="d-flex flex-column">
              <a :href="item.Url">
                <p v-html="item.Title" class="heading-level-3"></p>
              </a>
              <div class="d-flex flex-row flex-wrap">
                <div class="hits-block d-flex flex-row align-items-center">
                  <p>{{ hitProgram }}</p>
                </div>
                <div
                  class="hits-block d-flex flex-row align-items-center"
                  v-if="item.Points">
                  <p v-if="item.Level == 'Behörighetsgivande utbildning'">
                    {{ item.Points }} fup
                  </p>
                  <p v-else>{{ item.Points }} hp</p>
                </div>
                <div
                  class="hits-block d-flex flex-row align-items-center"
                  v-if="item.Level">
                  <p>{{ item.Level }}</p>
                </div>
                <div
                  class="hits-block d-flex flex-row flex-wrap align-items-center"
                  v-if="
                    item.EducationOccasions &&
                    item.EducationOccasions.length > 0
                  ">
                  <button
                    type="button"
                    data-toggle="collapse"
                    :data-target="`#${item.Code}-collapse`"
                    class="toggle-occasions-btn">
                    <p
                      class="d-flex flex-row flex-wrap align-items-center"
                      v-if="item.EducationOccasions.length == 1">
                      <span
                        class="circle--green"
                        v-if="item.HasOpenCourses"></span>
                      <span
                        class="circle--grey"
                        v-else-if="item.HasClosedCourses"></span>

                      {{ item.EducationOccasions.length }}
                      {{ educationOccasion }}
                    </p>
                    <p
                      class="d-flex flex-row flex-wrap align-items-center"
                      v-else>
                      <span
                        class="circle--green"
                        v-if="item.HasOpenCourses"></span>
                      <span
                        class="circle--grey"
                        v-else-if="item.HasClosedCourses"></span>
                      {{ item.EducationOccasions.length }}
                      {{ educationOccasions }}
                    </p>

                    <i class="material-icons down">keyboard_arrow_down</i>
                    <i class="material-icons up">keyboard_arrow_up</i>
                  </button>
                </div>
              </div>
            </div>
            <template v-if="item && item.EducationOccasions.length > 0">
              <div :id="`${item.Code}-collapse`" class="collapse">
                <div class="high d-flex flex-column" slot="content">
                  <div
                    class="hits-occasions d-flex flex-column flex-wrap"
                    v-for="occasion in item.EducationOccasions">
                    <div
                      class="d-flex flex-row flex-wrap aling-items-center w-100">
                      <strong
                        v-if="
                          occasion.Orientations &&
                          occasion.Orientations.length > 0
                        "
                        >{{ occasion.Orientations[0].Name }}</strong
                      >
                    </div>

                    <div class="hits-occasions-text">
                      <p>{{ occasion.TermStart }}</p>
                      <p>{{ occasion.StudyLocation }}</p>
                      <p>{{ occasion.StudyPace }}</p>

                      <a
                        :href="item.Url"
                        class="status-link d-flex flex-row align-items-center"
                        v-if="showDot('open', occasion)">
                        <span class="circle--green"></span>
                        {{ applicationOpen }}
                      </a>
                      <a
                        :href="item.Url"
                        class="status-link d-flex flex-row align-items-center"
                        v-if="showDot('late', occasion)">
                        <span class="circle--orange"></span>
                        {{ applicationLate }}
                      </a>
                      <a
                        :href="
                          'https://www.antagning.se/se/search?period=' +
                          occasion.TermStartAbbreviation.slice(0, 2) +
                          '+' +
                          occasion.TermStartAbbreviation.slice(2, 6) +
                          '&freeText=' +
                          occasion.RegistrationCode
                        "
                        class="status-link d-flex flex-row align-items-center"
                        v-if="showDot('closed', occasion)">
                        <span class="circle--grey"></span>
                        {{ applicationClosed }}
                      </a>
                      <a
                        :href="
                          'https://www.antagning.se/se/search?period=' +
                          occasion.TermStartAbbreviation.slice(0, 2) +
                          '+' +
                          occasion.TermStartAbbreviation.slice(2, 6) +
                          '&freeText=' +
                          occasion.RegistrationCode
                        "
                        class="status-link d-flex flex-row align-items-center"
                        v-if="showDot('canceled', occasion)">
                        <span class="circle--grey"></span>
                        {{ applicationCanceled }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </li>
        </template>
        <template v-if="item.Type.includes('Course')">
          <li :key="item.Code">
            <div class="d-flex flex-column hits-inner">
              <a :href="item.Url">
                <p class="heading-level-3" v-html="item.Title"></p>
              </a>

              <div class="d-flex flex-row flex-wrap">
                <div class="d-flex flex-row flex-wrap">
                  <div class="hits-block d-flex flex-row align-items-center">
                    <p>{{ hitCourse }}</p>
                  </div>
                  <div
                    class="hits-block d-flex flex-row align-items-center"
                    v-if="item.Points">
                    <p>{{ item.Points }} hp</p>
                  </div>
                  <div
                    class="hits-block d-flex flex-row align-items-center"
                    v-if="item.Level">
                    <p>{{ item.Level }}</p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </template>
      </ul>
    </template>
  </div>
</template>
